﻿import { Monitor, Moon, Sun } from "lucide-react";

import { useTheme } from "@/providers/theme-provider";
import { cn } from "@/lib/utils";

/**
 * 3-state toggle: light / dark / system.
 * Her tıklamada bir sonraki duruma geçer. Tooltip ve aria label ile erişilebilir.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  const next = theme === "light" ? "dark" : theme === "dark" ? "system" : "light";
  const Icon = theme === "light" ? Sun : theme === "dark" ? Moon : Monitor;
  const label =
    theme === "light" ? "Açık tema" : theme === "dark" ? "Koyu tema" : "Sistem teması";

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={`Temayı değiştir (şu an: ${label})`}
      title={label}
      className={cn(
        "inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground",
        className,
      )}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}
